<template>
  <div>
    <el-dialog
      title="選擇優惠券"
      :visible.sync="visible"
      class="couponSelect"
      :before-close="cancelHandle"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="query">
        <el-select v-model="query.card_type" placeholder="請選擇" @change="selectHandle">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="query.title"
          placeholder="請輸入卡券名稱"
          style="width: 300px"
          class="input-with-select"
        >
          <el-button slot="append" @click="queryHandle"> 查詢 </el-button>
        </el-input>
      </div>
      <div class="list">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :row-key="getRowKeys"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column :reserve-selection="true" type="selection" width="55" />
          <el-table-column label="卡劵類型" width="120">
            <template slot-scope="scope">
              <template v-if="scope.row.card_type == 'new_gift'"> 兌換券 </template>
              <template v-else-if="scope.row.card_type == 'gift'"> 兌換券 </template>
              <template v-else-if="scope.row.card_type == 'discount'"> 折扣卷 </template>
              <template v-else-if="scope.row.card_type == 'cash'"> 滿減券 </template>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="卡劵名稱" width="120" />
          <el-table-column prop="description" label="卡劵說明" show-overflow-tooltip />
          <el-table-column prop="fixed_term" label="卡劵有效期" show-overflow-tooltip>
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.date_type == 'DATE_TYPE_FIX_TIME_RANGE' ||
                  scope.row.date_type == 'DATE_TYPE_SHORT'
                "
              >
                {{ scope.row.begin_time | formatDataTime('YYYY-MM-DD hh:mm:ss') }} -
                {{ scope.row.end_time | formatDataTime('YYYY-MM-DD hh:mm:ss') }}
              </template>
              <template
                v-else-if="
                  scope.row.date_type == 'DATE_TYPE_FIX_TERM' ||
                  scope.row.date_type == 'DATE_TYPE_LONG'
                "
              >
                {{ scope.row.takeEffect }}
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="可領取庫存" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.quantity - scope.row.get_num }}
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="發送數量" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.give_num" placeholder="請輸入" type="number" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        style="text-align: center"
        background
        :current-page="paging.page_no"
        :page-sizes="[10, 20, 30]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <div class="tips">
        <p>已選擇：{{ multipleSelection.length }} 張，最多選擇 20 張優惠券</p>
      </div>
      <div class="btn">
        <el-button @click="cancelHandle"> 取消 </el-button>
        <el-button type="primary" @click="confirm"> 確定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    seletedCoupon: {
      type: Array
    }
  },
  data() {
    const options = [
      {
        label: '全部類型',
        value: 'all'
      },

      {
        label: '折扣卷',
        value: 'discount'
      },
      {
        label: '滿減券',
        value: 'cash'
      }
    ]
    if (this.VERSION_STANDARD) {
      options.push({
        label: '兌換券',
        value: 'new_gift'
      })
    }

    return {
      tableData: [],
      multipleSelection: [],
      loading: false,
      query: {
        card_type: 'all',
        title: ''
      },
      total: 0,
      paging: {
        page_no: 1,
        page_size: 10
      },
      options: options
    }
  },
  watch: {
    multipleSelection() {
      this.$emit('seletedDataHandle', this.multipleSelection)
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    async getConfig() {
      this.loading = true
      const { list, total_count } = await this.$api.coupons_package.couponList({
        ...this.query,
        ...this.paging
      })
      this.loading = false

      list.forEach((element) => {
        element.give_num = 0
      })

      this.tableData = list
      this.total = total_count
      this.$refs.multipleTable.clearSelection()
      if (this.seletedCoupon.length > 0) {
        this.seletedCoupon.forEach((item) => {
          console.log('this.seletedCoupon', this.seletedCoupon)
          this.$refs.multipleTable.toggleRowSelection(item)
        })

        this.seletedCoupon.forEach((itemX) => {
          this.tableData.forEach((itemY, indexY) => {
            if (itemX.card_id == itemY.card_id) {
              this.tableData.splice(indexY, 1, itemX)
            }
          })
        })
      }
    },
    closeHandle() {
      this.$emit('closeHandle')
    },
    cancelHandle() {
      this.multipleSelection = []
      this.$emit('seletedDataHandle', this.multipleSelection)
      this.$emit('closeHandle')
    },
    selectHandle(val) {
      this.query.card_type = val
      this.getConfig()
    },
    handleSizeChange(val) {
      this.paging.page_size = val
      this.paging.page_no = 1
      this.getConfig()
    },
    handleCurrentChange(val) {
      this.paging.page_no = val
      this.getConfig()
    },
    queryHandle() {
      this.paging.page_no = 1
      this.getConfig()
    },
    confirm() {
      if (this.multipleSelection.length <= 0) {
        return this.$message.error('請選擇兌換券~')
      }

      if (this.multipleSelection.length > 20) {
        return this.$message.error('最多可以選擇20張優惠券~')
      }

      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (
          this.multipleSelection[i].give_num >
          this.multipleSelection[i].quantity - this.multipleSelection[i].get_num
        ) {
          return this.$message.error('所選劵包發送數量大於庫存，請修改~')
        }

        if (String(this.multipleSelection[i].give_num).indexOf('.') == '1') {
          return this.$message.error('所選優惠券發送數量必須為正整數~')
        }

        if (this.multipleSelection[i].give_num < 1) {
          return this.$message.error('所選優惠券發送數量不可小於1~')
        }
      }

      this.$emit('seletedDataHandle', this.multipleSelection)
      this.$emit('closeHandle')
    },
    handleSelectionChange(val) {
      if (val) {
        this.multipleSelection = val
      }
    },
    getRowKeys(val) {
      return val.card_id
    }
  }
}
</script>

<style lang="scss" scoped>
.couponSelect {
  .query {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .list {
    padding: 30px 0px;
  }
  .tips {
    padding: 10px;
    padding-bottom: 0;
    color: #999;
  }
  .btn {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
<style lang="scss">
.couponSelect {
  .el-dialog {
    min-width: 1000px;
  }
}
</style>
